import sensorDitoImg from "../images/ProductImg/SensorDito.jpg";
import sensorFogImg from "../images/ProductImg/SensorFog.jpg";
import sensorFFImg from "../images/ProductImg/SensorFF.jpg";

import touchGGPCapImg from '../images/ProductImg/TouchGGPCap.jpg';
import touchPGPCapImg from '../images/ProductImg/TouchPGPCap.jpg';
import touchGFFPCapImg from '../images/ProductImg/TouchGFFPCap.jpg';

import tdmOcaDBondImg from '../images/ProductImg/TdmOcaDBond.jpg';
import tdmTocaDBondImg from '../images/ProductImg/TdmTocaDBond.jpg';
import tdmOcrDbondImg from '../images/ProductImg/TdmOcrDBond.jpg';

export const sensorDitoData = [
  {
    id: 1,
    // image: require('../images/ProductImg/SensorDito.jpg'),
    image: sensorDitoImg,
    alt: 'ProductImg/SensorDito.jpg',
    name: 'PCAP Sensor Introduce',
    title: 'PCAP Sensor Introduce',
    text:
      ' • 電極在觸控螢幕的感應器側以網格圖案排列\n' +
      ' • 透過手指摸觸表面時發生的電荷變化來偵測觸摸點\n' +
      ' • PCAP Touch具有耐用性的優勢，不會損害表面或致功能片失效\n',
    textEng: 'Electrodes are aligned in a grid pattern on the sensor side of touch panel. ' +
      'The grid detects the touch point by sensing the change of electrical charges ' +
      'that occur when a finger touches the surface of the touch panel. ' +
      'The PCAP touch technology has the added advantage of durability ' +
      'because it has no degradation to the surface of the display or the performance of the touch sensor.',
    describe: 'DITO PCAP觸控功能片',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 2,
    // image: require('../images/ProductImg/SensorDito.jpg'),
    image: sensorDitoImg,
    alt: 'ProductImg/SensorDito.jpg',
    name: 'DITO功能片常規',
    title: 'Advantages of PCAP DITO Sensor',
    text: '     1、多點觸控功能                    2、使用壽命長\n' +
      '     3、可調式靈敏度                    4、易於整合解決\n' +
      '     5、耐用性和可靠性高            6、可自訂且直觀\n' +
      '     7、具有影像清晰度',
    describe: 'Multi-touch capability ' +
      'Longevity ' +
      'Adjustable sensitivity ' +
      'Integrated solutions ' +
      'Durability and reliability ' +
      'Customisable and intuitive ' +
      'Image clarity',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 3,
    // image: require('../images/ProductImg/SensorDito.jpg'),
    image: sensorDitoImg,
    alt: 'ProductImg/SensorDito.jpg',
    name: 'DITO Glass功能片尺寸',
    title: 'DITO Glass Sensor Size',
    text: 'DITO Touch Sensor各尺寸都有解決方案，具有優勢\n' +
      '尺寸配合VA分別為:\n' +
      '      1、2~10吋 / 消費類\n' +
      '      2、7~12吋 / 人機介面\n' +
      '      3、14~18吋 / 工葉控制類\n' +
      '      4、4~20吋 / 醫療類\n' +
      '      5、15~21吋 / AIO\n' +
      '厚度:0.4、0.55、0.7、1.1、1.6、2.0mm',
    describe: 'DITO PCAP觸控功能片從小尺寸到大尺寸都有全面的解決方案，並具有最大的優勢',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 4,
    image: sensorDitoImg,
    // image: require('../images/ProductImg/SensorDito.jpg'),
    name: 'Multi-touch',
    title: 'Multi-touch',
    text: 'PCAP Touch技術完全支援多點觸控。\n' +
      ' • 多點觸控是指觸摸系統同時檢測和解析至少2個觸摸點的能力\n' +
      ' • 多點觸控式螢幕不僅可以識別單個觸摸，還可以用多個處理手勢\n' +
      ' • 多點觸控可實現旋轉、縮放和滑動，以及多個同時操作',
    describe: '',
    // text: 'PCAP sensor enables input through multiple touch points, lines and gestures',
    link: 'https://www.hlzoptics.com',
    time: '2025/1/4',
  },
  {
    id: 5,
    image: sensorDitoImg,
    // image: require('../images/ProductImg/SensorDito.jpg'),
    name: 'DITO功能片',
    title: 'HLZ 現已開發的尺寸',
    text: '     1、小於5吋：2吋/30款、3吋/50款、4吋/78款、5吋/120款\n' +
      '     2、6~7吋：6吋/12款、7吋/260款\n' +
      '     3、8~9吋：8.0吋/130款、9.0吋/25款、9.7吋/10款\n' +
      '     4、10.1吋/280款、10.4吋/20款\n' +
      '     5、．．．．．',
    describe: 'AR, AF coating is available for customized requirement',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 6,
    image: sensorDitoImg,
    // image: require('../images/ProductImg/SensorDito.jpg'),
    name: 'DITO Glass Sensor Structure',
    title: 'DITO Glass 功能片結構',
    text:
      ' • 單片玻璃，玻璃正反面使用方阻60~120Ω/sq ITO玻璃\n' +
      ' • 周邊使用銀線連接FPC\n' +
      ' • 依邊寬要求採用雷射雕刻銀漿塊成為P:0.08mm銀導線\n' +
      ' • 銀線並覆蓋絕緣保護層，避免刮傷破壞線路\n' +
      ' • ITO trace 採用蝕刻清洗製程',
    describe: '',
    link: 'https://www.hlzoptics.com',
    time: '2025/1/4',
  }

]

export const sensorFFData = [
  {
    id: 1,
    image: sensorFFImg,
    alt: 'ProductImg/SensorFF.jpg',
    name: 'film+oca+film+oca PCAP Touch Sensor',
    title: 'Film+Oca+Film+Oca功能片',
    text:
      ' • 基於客戶服務合利资科技協助客戶解決GFF結構\n' +
      ' • Touch功能片設計與生產.....',
    describe: 'Base customer require, We support ff sensor design and development GFF touch panel',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 2,
    image: sensorFFImg,
    alt: 'ProductImg/SensorFF.jpg',
    name: 'Advantages of PCAP FF Sensor',
    title: 'Advantages of PCAP FF Sensor',
    text:
      '1、易加工\n' +
      '2、超薄......',
    describe: 'FilmFilm PCAP觸控功能片從小尺寸到大尺寸都有全面的解決方案，並具有最大的優勢',
  },
  {
    id: 3,
    image: sensorFFImg,
    alt: 'ProductImg/SensorFF.jpg',
    name: 'FilmFilm 功能片尺寸',
    title: 'FilmFilm Sensor Size',
    text:
      'FilmFilm Touch Sensor從小到大尺寸都有解決方案，\n' +
      '並具有最大的優勢\n' +
      '尺寸配合VA分別為：\n' +
      '   1、2~10吋/消費類\n' +
      '   2、7~12吋/人機介面\n' +
      '   3、14~18吋/工葉控制類\n' +
      '   4、4~20吋醫療類\n' +
      '   5、15~21吋/AIO\n' +
      '厚度；0.4、0.55、0.7、1.1、1.6、2.0mm\n',
    describe: 'FilmFilm PCAP觸控功能片從小尺寸到大尺寸都有全面的解決方案，並具有最大的優勢',
  },
  {
    id: 6,
    // image: require('../images/ProductImg/SensorFF.jpgg'),
    image: sensorFFImg,
    alt: 'ProductImg/SensorFF.jpg',
    name: 'Film Film Sensor Structure',
    title: 'Film Film 功能片結構',
    text: 
      ' • 雙層薄膜\n' +
      ' • 上下層ITO膜使用方阻為60~120Ω/sq PET薄膜\n' +
      ' • 周邊使用銀或黃光製程Mo/Al導線連接FPC\n' +
      ' • 銀導線pitch 0.8mm，金屬導線可達xxum\n' +
      ' • 金屬導線導電性與可鬧竟均遠高於銀道線\n' +
      ' • ITO trace 採用刨光顯影製程',
    describe: '',
    link: 'https://www.hlzoptics.com',
    time: '2025/1/4',
  }
]

export const sensorFogData = [
  {
    id: 1,
    image: sensorFogImg,
    alt: 'ProductImg/SensorFog.jpg',
    name: 'Senor Bonding FPC',
    title: 'Senor Bonding FPC',
    text: '功能片熱壓FPC或FPCA為一體產品',
    link: 'https://www.hlzoptics.com'
  },
  {
    id: 2,
    image: sensorFogImg,
    alt: 'ProductImg/SensorFog.jpg',
    name: 'COB with Contoller',
    title: 'Sensor+FPC(COB type) with Contoller',
    text:
      'Glass或FF 功能片與FPC連接成一個整體提供給客戶\n' +
      '客戶省去熱壓工序\n' +
      '專業熱壓對產品的可靠性獲得極大的提升\n' +
      '控制器選用EETI、Ilitek、WeiDa 等知名廠商的IC\n' +
      '使用控制器一般應用於通道數較多大尺寸產品\n',
    link: 'https://www.hlzoptics.com'
  },
  {
    id: 3,
    image: sensorFogImg,
    alt: 'ProductImg/SensorFog.jpg',
    name: 'COF Sensor with FPCA',
    title: 'Sensor+FPCA(COF type)',
    text:
      'Glass或是FF功能片與 FPCA 連接成一個整體出貨\n' +
      '客戶省去熱壓工序\n' +
      '專業熱壓對產品的可靠性獲得極大的提升\n' +
      'Control IC: FocalTech、Goodix、EETI、Ilitek\n' +
      '                   WeiDa... 等知名廠商 IC\n' +
      '使用 FPCA 方式多用於小尺寸消費等種類\n',
    link: 'https://www.hlzoptics.com'
  }
]

export const touchGGPCapData = [
  {
    id: 1,
    image: touchGGPCapImg,
    alt: 'ProductImg/TouchGGPCap.jpg',
    name: 'GG PCAP Touch 1',
    title: 'GG PCAP Touch 1',
    text: 'G+G PCAP 觸控面板 介紹一',
    link: 'https://www.hlzoptics.com'
  },
  {
    id: 2,
    image: touchGGPCapImg,
    alt: 'ProductImg/TouchGGPCap.jpg',
    name: 'GG PCAP Touch 2',
    title: 'GG PCAP Touch 2',
    text: 'G+G PCAP 觸控面板 介紹二',
    link: 'https://www.hlzoptics.com'
  },
  {
    id: 3,
    image: touchGGPCapImg,
    alt: 'ProductImg/TouchGGPCap.jpg',
    name: 'GG PCAP Touch 3',
    title: 'GG PCAP Touch 3',
    text: 'G+G PCAP 觸控面板 介紹三',
    link: 'https://www.hlzoptics.com'
  }
]

export const touchPGPCapData = [
  {
    id: 1,
    image: touchPGPCapImg,
    alt: 'ProductImg/TouchPGPCap.jpg',
    name: 'PG PCAP Touch 1',
    title: 'PG PCAP Touch 1',
    text: 'P+G PCAP 觸控面板 介紹一',
    link: 'https://www.hlzoptics.com'
  },
  {
    id: 2,
    image: touchPGPCapImg,
    alt: 'ProductImg/TouchPGPCap.jpg',
    name: 'PG PCAP Touch 2',
    title: 'PG PCAP Touch 2',
    text: 'P+G PCAP 觸控面板 介紹二',
    link: 'https://www.hlzoptics.com'
  },
  {
    id: 3,
    image: touchPGPCapImg,
    alt: 'ProductImg/TouchPGPCap.jpg',
    name: 'PG PCAP Touch 3',
    title: 'PG PCAP Touch 3',
    text: 'P+G PCAP 觸控面板 介紹三',
    link: 'https://www.hlzoptics.com'
  }
]

export const touchGFFPCapData = [
  {
    id: 1,
    image: touchGFFPCapImg,
    alt: 'ProductImg/TouchGFFPCap.jpg',
    name: 'GFF PCAP Touch 1',
    title: 'GFF PCAP Touch 1',
    text: 'G+FF PCAP 觸控面板 介紹一',
    link: 'https://www.hlzoptics.com'
  },
  {
    id: 2,
    image: touchGFFPCapImg,
    alt: 'ProductImg/TouchGFFPCap.jpg',
    name: 'GFF PCAP Touch 2',
    title: 'GFF PCAP Touch 2',
    text: 'G+FF PCAP 觸控面板 介紹二',
    link: 'https://www.hlzoptics.com'
  },
  {
    id: 3,
    image: touchGFFPCapImg,
    alt: 'ProductImg/TouchGFFPCap.jpg',
    name: 'GFF PCAP Touch 3',
    title: 'GFF PCAP Touch 3',
    text: `G+FF PCAP 觸控面板 介紹三,  G+FF PCAP 觸控面板 介紹三,  G+FF PCAP 觸控面板 介紹三,  G+FF PCAP 觸控面板 介紹三,
            G+FF PCAP 觸控面板 介紹三,  G+FF PCAP 觸控面板 介紹三,  G+FF PCAP 觸控面板 介紹三,  G+FF PCAP 觸控面板 介紹三,
              G+FF PCAP 觸控面板 介紹三,  G+FF PCAP 觸控面板 介紹三`,
    link: 'https://www.hlzoptics.com'
  }
]

export const tdmOcaDbData = [
  {
    id: 1,
    // image: require('../images/ProductImg/TdmOcaDBond.jpg'),
    image: tdmOcaDBondImg,
    alt: 'ProductImg/TdmOcaDBond.jpg',
    name: 'OCA Optical Bonding 1',
    title: 'OCA Optical Bonding 1',
    text: 'OCA TP+LCM=>TDM全貼合一',
    text_eng: 'OCA Optical Bonding/Direct Bonding 1',
    text_cht: 'OCA TP+LCM=>TDM全貼合一',
    text_chs: 'OCA TP+LCM=>TDM全貼合一',
    describe: 'OCA Optical Bonding/Direct Bonding 1',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 2,
    // image: require('../images/ProductImg/TdmOcaDBond.jpg'),
    image: tdmOcaDBondImg,
    alt: 'ProductImg/TdmOcaDBond.jpg',
    name: 'OCA Optical Bonding 2',
    title: 'OCA Optical Bonding 2',
    text: 'OCA TP+LCM=>TDM全貼合二',
    text_eng: 'OCA Optical Bonding/Direct Bonding 2',
    text_cht: 'OCA TP+LCM=>TDM全貼合二',
    text_chs: 'OCA TP+LCM=>TDM全貼合二',
    describe: 'OCA Optical Bonding/Direct Bonding 2',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
]

export const tdmTocaDbData = [
  {
    id: 1,
    // image: require('../images/ProductImg/TdmTocaDBond.jpg'),
    image: tdmTocaDBondImg,
    alt: 'ProductImg/TdmTocaDBond.jpg',
    name: 'TOCA Optical Bonding 1',
    title: 'TOCA Optical Bonding 1',
    text: 'TOCA TP+LCM=>TDM全貼合一',
    text_eng: 'TOCA Optical Bonding/Direct Bonding 1',
    text_cht: 'TOCA TP+LCM=>TDM全貼合一',
    text_chs: 'TOCA TP+LCM=>TDM全貼合一',
    describe: 'TOCA Optical Bonding/Direct Bonding 1',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 2,
    // image: require('../images/ProductImg/TdmTocaDBond.jpg'),
    image: tdmTocaDBondImg,
    alt: 'ProductImg/TdmTocaDBond.jpg',
    name: 'TOCA Optical Bonding 2',
    title: 'TOCA Optical Bonding 2',
    text: 'TOCA TP+LCM=>TDM全貼合二',
    text_eng: 'TOCA Optical Bonding/Direct Bonding 2',
    text_cht: 'TOCA TP+LCM=>TDM全貼合二',
    text_chs: 'TOCA TP+LCM=>TDM全貼合二',
    describe: 'TOCA Optical Bonding/Direct Bonding 2',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
]

export const tdmOcrDbData = [
  {
    id: 1,
    // image: require('../images/ProductImg/TdmOcrDBond.jpg'),
    image: tdmOcrDbondImg,
    alt: 'ProductImg/TdmOcrDBond.jpg',
    name: 'OCR Optical Bonding 1',
    title: 'OCR Optical Bonding 1',
    text: 'OCR TP+LCM=>TDM全貼合一',
    text_eng: 'OCR Optical Bonding/Direct Bonding 1',
    text_cht: 'OCR TP+LCM=>TDM全貼合一',
    text_chs: 'OCR TP+LCM=>TDM全貼合一',
    describe: 'OCR Optical Bonding/Direct Bonding 1',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 2,
    // image: require('../images/ProductImg/TdmOcrDBond.jpg'),
    image: tdmOcrDbondImg,
    alt: 'ProductImg/TdmOcrDBond.jpg',
    name: 'OCR Optical Bonding 2',
    title: 'OCR Optical Bonding 2',
    text: 'OCR TP+LCM=>TDM全貼合二',
    text_eng: 'OCR Optical Bonding/Direct Bonding 2',
    text_cht: 'OCR TP+LCM=>TDM全貼合二',
    text_chs: 'OCR TP+LCM=>TDM全貼合二',
    describe: 'OCR Optical Bonding/Direct Bonding 2',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 3,
    // image: require('../images/ProductImg/TdmOcrDBond.jpg'),
    image: tdmOcrDbondImg,
    alt: 'ProductImg/TdmOcrDBond.jpg',
    name: 'OCR Optical Bonding 3',
    title: 'OCR Optical Bonding 3',
    text: 'OCR TP+LCM=>TDM全貼合三',
    text_eng: 'OCR Optical Bonding/Direct Bonding 3',
    text_cht: 'OCR TP+LCM=>TDM全貼合三',
    text_chs: 'OCR TP+LCM=>TDM全貼合三',
    describe: 'OCR Optical Bonding/Direct Bonding 3',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
]

export const tpCtrlBdData = [
  {
    id: 1,
    image: require('../images/ComponentImg/touchCtrl-1.png'),
    alt: 'ComponentImg/touchCtrl-1.png',
    fbLink: 'https://www.facebook.com',
    name: 'ILI2511 name',
    title: 'ILI2510 title',
    text: 'ILI2510: text Lorem ipsum dolor st amet, consectetur adipising elit. Facilis, totam maiore',
    describe: 'ILI2510: describe Oorem lpsum dolor sttie amert',
  },
  {
    id: 2,
    image: require('../images/ComponentImg/touchCtrl-2.png'),
    alt: 'ComponentImg/touchCtrl-2.png',
    linkedinLink: 'https://www.linkedin.com',
    name: 'ILI2510 name',
    title: 'ILI2510 title',
    text: 'ILI2510: text Lorem ipsum dolor st amet, consectetur adipising elit. Facilis, totam maiore',
    describe: 'ILI2510: describe Oorem lpsum dolor sttie amert',
  },
  {
    id: 3,
    image: require('../images/ComponentImg/touchCtrl-3.png'),
    alt: 'ComponentImg/touchCtrl-3.png',
    twitterLink: 'https://www.twitter.com',
    name: 'ILI2302 name',
    title: 'ILI2510 title',
    text: 'ILI2510: text Lorem ipsum dolor st amet, consectetur adipising elit. Facilis, totam maiore',
    describe: 'ILI2510: describe Oorem lpsum dolor sttie amert',
  },
  {
    id: 4,
    image: require('../images/ComponentImg/touchCtrl-4.png'),
    alt: 'ComponentImg/touchCtrl-4.png',
    linkedinLink: 'https://www.linkedin.com',
    name: 'ILI2510 name',
    title: 'ILI2510 title',
    text: 'ILI2510: text Lorem ipsum dolor st amet, consectetur adipising elit. Facilis, totam maiore',
    describe: 'ILI2510: describe Oorem lpsum dolor sttie amert',
  },
  {
    id: 5,
    image: require('../images/ComponentImg/touchCtrl-5.png'),
    fbLink: 'https://www.facebook.com',
    name: 'ILI2510 name',
    title: 'ILI2510 title',
    text: 'ILI2510: text Lorem ipsum dolor st amet, consectetur adipising elit. Facilis, totam maiore',
    describe: 'ILI2510: describe Oorem lpsum dolor sttie amert',
  },
  {
    id: 6,
    image: require('../images/ComponentImg/touchCtrl-1.png'),
    alt: 'ComponentImg/touchCtrl-1.png',
    twitterLink: 'https://www.twitter.com',
    name: 'ILI2510 name',
    title: 'ILI2510 title',
    text: 'ILI2510: text Lorem ipsum dolor st amet, consectetur adipising elit. Facilis, totam maiore',
    describe: 'ILI2510: describe Oorem lpsum dolor sttie amert',
  },
  {
    id: 7,
    image: require('../images/ComponentImg/touchCtrl-2.png'),
    alt: 'ComponentImg/touchCtrl-2.png',
    linkedinLink: 'https://www.linkedin.com',
    name: 'ILI2510 name',
    title: 'ILI2510 title',
    text: 'ILI2510: text Lorem ipsum dolor st amet, consectetur adipising elit. Facilis, totam maiore',
    describe: 'ILI2510: describe Oorem lpsum dolor sttie amert',
  },
  {
    id: 8,
    image: require('../images/ComponentImg/touchCtrl-3.png'),
    alt: 'ComponentImg/touchCtrl-3.png',
    twitterLink: 'https://www.facebook.com',
    name: 'ILI2510 name',
    title: 'ILI2510 title',
    text: 'ILI2510: text Lorem ipsum dolor st amet, consectetur adipising elit. Facilis, totam maiore',
    describe: 'ILI2510: describe Oorem lpsum dolor sttie amert',
  }
]
